const tabs = require(MODULES_PATH + '/tabs');

let officesPartners = new tabs({
    selectorClass: 'offices-partners',
});

let offices = new tabs({
    selectorClass: 'offices',
});

let partners = new tabs({
    selectorClass: 'partners',
});
